import { Controller } from "@hotwired/stimulus"

export default class ImportController extends Controller {
  declare modalTarget: HTMLDivElement
  declare frameTarget: HTMLElement
  declare headerTarget: HTMLElement

  static targets = ["modal", "frame", "header"]

  modalTargetConnected(element: HTMLDivElement): void {
    element.addEventListener("show.bs.modal", this.handleModalShow.bind(this))
    element.addEventListener("hidden.bs.modal", this.handleModalHidden.bind(this))
  }

  private handleModalShow(event: Event): void {
    const modalEvent = event as MouseEvent
    const button = modalEvent.relatedTarget

    if (button instanceof HTMLElement) {
      const src = button.dataset.modalSrc
      if (src) {
        this.frameTarget.innerHTML = ""
        this.frameTarget.setAttribute("src", src)
      }
    }
  }

  private handleModalHidden(): void {
    this.frameTarget.innerHTML = ""
    this.headerTarget.innerHTML = ""
    this.dispatch("importComplete")
  }
}
